// extracted by mini-css-extract-plugin
export var container = "_5d-1";
export var editor = "_5d-2";
export var resizable = "_5d-3";
export var wrapper = "_5d-0";